module.exports = __webpack_public_path__ + "img/03-5.e89da6a9.png";